<template>
  <div>
    <Header :ifbluejo="ifbluejo"></Header>
    <breadcrumb :secondhref="secondhref" :secondtest="secondtest"></breadcrumb>
    <div class="content-body body-box" style="overflow: hidden">
      <div class="main-item">
        <div class="body-left">
          <div class="test-box">
            <div class="test-head">
              <span class="test-title">加入学会</span>
            </div>
          </div>
          <div style="background-color: #ffffff;">
            <!--文章内容-->
            <div style="text-align: left;padding: 25px;font-size: 14px;" v-html="text">
            </div>
          </div>
        </div>
        <!--<div class="body-right">
          <contact></contact>
        </div>-->
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from '@/components/footer/footer.vue'
import Header from '@/components/header/header.vue'
import breadcrumb from '@/components/breadcrumb/breadcrumb.vue'
import contact from '@/components/contact/contact.vue'
import HttpServer from '@/utils' // 接口请求
import '../../node_modules/bootstrap/dist/js/bootstrap.js'

export default {
  name: 'join',
  data () {
    return {
      // 所在页面的名称
      topName: 'join',
      // 顶部导航栏
      ifbluejo: {
        color: '#0051bd'
      },
      // 面包屑导航栏
      secondhref: '/join',
      secondtest: '加入学会',
      // 文章内容(html)
      text: ''
    }
  },
  components: {
    Footer: Footer,
    Header: Header,
    breadcrumb: breadcrumb,
    contact: contact
  },
  mounted () {
    // 调用本页接口
    HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName).then(res => {
      this.text = res.data
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @import '../../node_modules/bootstrap/dist/css/bootstrap.css';
  @import 'joinprocess/main.css';

  .body-box{
    margin-top:10px;
    background-color: #f5f5f5;
  }
  .body-left{
    width: 950px;
    float: left;
  }
  .body-right{
    width: 200px;
    float: right;
  }
  .test-box{
    padding: 12px;
    background-color: #ffffff;
    font-size: 12px;
    text-align: left;
  }
  .test-head{
    height:30px;
    margin-bottom: 15px;
    border-bottom: 1px solid #d7d7d7;
  }
  .test-title{
    font-size: 14px
  }
</style>



// WEBPACK FOOTER //
// src/components/join.vue